﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_dialogHelpList from './tpl/dialogHelpList.html';
import View_DialogHelpListItem from './dialogHelpListItem';

export default Marionette.CollectionView.extend({
    tagName: 'dialogHelpList',
    childViewContainer: '#dialogHelpList',
    childView: View_DialogHelpListItem,
    getTemplate: function () {
        return tpl_dialogHelpList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
